"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTRY_BOOKINGS_RUNNING_ENVIRONMENT = exports.SENTRY_BOOKINGS_VIEWER_SCRIPT_DNS = void 0;
exports.SENTRY_BOOKINGS_VIEWER_SCRIPT_DNS = 'https://48193eb4f61b42c99e44a650c132d962@sentry.wixpress.com/177';
exports.SENTRY_BOOKINGS_RUNNING_ENVIRONMENT = 'ooi-viewer-script';
//# sourceMappingURL=sentry.const.js.map